/* eslint-disable react/prop-types */
import { phoneMask } from '@lib/IMask';
import useMask from '@lib/useMask';
import { TextField } from '@material-ui/core';
import React from 'react';

export default function PhoneField({ onChange, ...props }) {
  const { ref } = useMask({
    mask: phoneMask,
    onChange,
  });

  return (
    <TextField
      fullWidth
      id="phone"
      label="Phone"
      // MUI only wires label -> input through htmlFor/id. Without the id above
      // the "Phone" text was purely visual: the field had no accessible name,
      // so a screen reader announced an unlabelled edit box. aria-label is
      // belt and braces for when a caller overrides the id.
      inputProps={{ 'aria-label': 'Phone', ref, type: 'tel' }}
      {...props}
    />
  );
}
